// import React from "react";

// const CATEGORIES = ["all", "easy", "medium", "hard"];

// const categoryColors = {
//   easy: { bg: "#d1fae5", color: "#065f46", label: "Easy" },
//   medium: { bg: "#fef3c7", color: "#92400e", label: "Medium" },
//   hard: { bg: "#fee2e2", color: "#991b1b", label: "Hard" },
// };

// const TextSelector = ({
//   paragraphs,
//   selectedParagraph,
//   onSelect,
//   category,
//   setCategory,
//   language,
//   activeTime,
//   setActiveTime,
// }) => {
//   return (
//     <div className="text-selector-wrapper">

//       {/* ── Category Filter ── */}
//       <div className="category-filter-row">
//         <span className="filter-label">📂 Filter by difficulty:</span>
//         <div className="category-tabs">
//           {CATEGORIES.map((cat) => (
//             <button
//               key={cat}
//               className={`category-tab ${category === cat ? "active" : ""}`}
//               onClick={() => setCategory(cat)}
//             >
//               {cat === "all"
//                 ? "🗂️ All"
//                 : cat === "easy"
//                 ? "🟢 Easy"
//                 : cat === "medium"
//                 ? "🟡 Medium"
//                 : "🔴 Hard"}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* ── Paragraph Cards Grid ── */}
//       <div className="paragraphs-grid">
//         {paragraphs.length === 0 ? (
//           <div className="no-paragraphs">
//             <span>😕 No paragraphs found for this filter.</span>
//           </div>
//         ) : (
//           paragraphs.map((para) => {
//             const isSelected = selectedParagraph?.id === para.id;
//             const catStyle = categoryColors[para.category];
//             const wordCount = para.text.trim().split(/\s+/).length;

//             return (
//               <div
//                 key={para.id}
//                 className={`paragraph-card ${isSelected ? "selected" : ""}`}
//                 onClick={() => onSelect(para)}
//               >
//                 {/* Card Header */}
//                 <div className="card-header">
//                   <h4 className="card-title">{para.title}</h4>
//                   <span
//                     className="card-category-badge"
//                     style={{
//                       backgroundColor: catStyle.bg,
//                       color: catStyle.color,
//                     }}
//                   >
//                     {catStyle.label}
//                   </span>
//                 </div>

//                 {/* Card Preview */}
//                 <p className="card-preview">
//                   {para.text.length > 100
//                     ? para.text.substring(0, 100) + "..."
//                     : para.text}
//                 </p>

//                 {/* Card Meta */}
//                 <div className="card-meta">
//                   <span className="meta-item">
//                     📝 {wordCount} words
//                   </span>
//                   <span className="meta-item">
//                     ⏱️ ~{para.estimatedTime}s
//                   </span>
//                   <span className="meta-item">
//                     🔤 {para.text.length} chars
//                   </span>
//                 </div>

//                 {/* Selected Indicator */}
//                 {isSelected && (
//                   <div className="card-selected-indicator">
//                     ✅ Selected
//                   </div>
//                 )}
//               </div>
//             );
//           })
//         )}
//       </div>

//       {/* ── Time Override (shown only when a paragraph is selected) ── */}
//       {selectedParagraph && (
//         <div className="time-override-section">
//           <div className="time-override-card">
//             <div className="time-override-header">
//               <span className="time-override-title">
//                 ⏱️ Timer for:{" "}
//                 <strong>{selectedParagraph.title}</strong>
//               </span>
//               <span className="time-override-hint">
//                 Auto-set based on length. You can adjust it below.
//               </span>
//             </div>

//             {/* Preset Buttons */}
//             <div className="timer-presets">
//               {[30, 60, 90, 120, 180].map((t) => (
//                 <button
//                   key={t}
//                   className={`timer-preset-btn ${activeTime === t ? "active" : ""}`}
//                   onClick={() => setActiveTime(t)}
//                 >
//                   {t >= 60 ? `${t / 60}m` : `${t}s`}
//                 </button>
//               ))}
//               <button
//                 className={`timer-preset-btn ${
//                   activeTime === selectedParagraph.estimatedTime ? "active" : ""
//                 }`}
//                 onClick={() => setActiveTime(selectedParagraph.estimatedTime)}
//               >
//                 🎯 Auto ({selectedParagraph.estimatedTime}s)
//               </button>
//             </div>

//             {/* Manual Input */}
//             <div className="timer-manual-row">
//               <label className="timer-manual-label">Custom seconds:</label>
//               <input
//                 type="number"
//                 min={10}
//                 max={600}
//                 value={activeTime}
//                 onChange={(e) =>
//                   setActiveTime(
//                     Math.max(10, Math.min(600, Number(e.target.value)))
//                   )
//                 }
//                 className="timer-number-input"
//               />
//               <span className="timer-unit">seconds</span>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TextSelector;

// components/typing/TextSelector.js
import React from "react";

const DIFFICULTIES = ["all", "easy", "medium", "hard"];

const difficultyColors = {
  easy:   { bg: "#d1fae5", color: "#065f46", label: "🟢 Easy"   },
  medium: { bg: "#fef3c7", color: "#92400e", label: "🟡 Medium" },
  hard:   { bg: "#fee2e2", color: "#991b1b", label: "🔴 Hard"   },
};

const accessColors = {
  free:    { bg: "#d1fae5", color: "#065f46", label: "🆓 Free"    },
  premium: { bg: "#ede9fe", color: "#4c1d95", label: "💎 Premium" },
};

const TextSelector = ({
  paragraphs,
  selectedParagraph,
  onSelect,
  language,
  activeTime,
  setActiveTime,
  hasSubscription,
}) => {
  return (
    <div className="text-selector-wrapper">

      {/* ── Paragraph Cards Grid ── */}
      <div className="paragraphs-grid">
        {paragraphs.length === 0 ? (
          <div className="no-paragraphs">
            <span>😕 No paragraphs found for this filter.</span>
          </div>
        ) : (
          paragraphs.map((para) => {
            // ✅ Use _id (MongoDB) instead of id (JSON)
            const isSelected  = selectedParagraph?._id === para._id;
            // ✅ Use difficulty instead of category
            const diffStyle   = difficultyColors[para.difficulty] || difficultyColors.easy;
            const accessStyle = accessColors[para.accessType]     || accessColors.free;
            const wordCount   = para.text.trim().split(/\s+/).length;
            const isPremiumLocked = para.accessType === "premium" && !hasSubscription;

            return (
              <div
                key={para._id}
                className={`paragraph-card 
                  ${isSelected       ? "selected"       : ""} 
                  ${isPremiumLocked  ? "premium-locked" : ""}
                `}
                onClick={() => {
                  if (!isPremiumLocked) onSelect(para);
                }}
                style={{ cursor: isPremiumLocked ? "not-allowed" : "pointer" }}
              >
                {/* ── Card Header ── */}
                <div className="card-header">
                  <h4 className="card-title">{para.title}</h4>
                  <div className="card-badges">
                    {/* Difficulty badge */}
                    <span
                      className="card-category-badge"
                      style={{
                        backgroundColor: diffStyle.bg,
                        color:           diffStyle.color,
                      }}
                    >
                      {diffStyle.label}
                    </span>

                    {/* Access type badge */}
                    <span
                      className="card-access-badge"
                      style={{
                        backgroundColor: accessStyle.bg,
                        color:           accessStyle.color,
                      }}
                    >
                      {accessStyle.label}
                    </span>
                  </div>
                </div>

                {/* ── Topic tag ── */}
                {para.topic && (
                  <div className="card-topic-tag">
                    📁 {para.topic}
                  </div>
                )}

                {/* ── Card Preview ── */}
                <p className="card-preview">
                  {isPremiumLocked
                    ? "🔒 Subscribe to unlock this premium paragraph."
                    : para.text.length > 100
                    ? para.text.substring(0, 100) + "..."
                    : para.text}
                </p>

                {/* ── Card Meta ── */}
                <div className="card-meta">
                  <span className="meta-item">📝 {wordCount} words</span>
                  <span className="meta-item">⏱️ ~{para.estimatedTime}s</span>
                  <span className="meta-item">🔤 {para.text.length} chars</span>
                </div>

                {/* ── Premium lock overlay message ── */}
                {isPremiumLocked && (
                  <div className="card-premium-lock">
                    💎 Premium — Contact admin to subscribe
                  </div>
                )}

                {/* ── Selected Indicator ── */}
                {isSelected && (
                  <div className="card-selected-indicator">✅ Selected</div>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* ── Time Override (shown only when a paragraph is selected) ── */}
      {selectedParagraph && (
        <div className="time-override-section">
          <div className="time-override-card">
            <div className="time-override-header">
              <span className="time-override-title">
                ⏱️ Timer for: <strong>{selectedParagraph.title}</strong>
              </span>
              <span className="time-override-hint">
                Auto-set based on length. You can adjust it below.
              </span>
            </div>

            {/* Preset Buttons */}
            <div className="timer-presets">
              {[30, 60, 90, 120, 180].map((t) => (
                <button
                  key={t}
                  className={`timer-preset-btn ${activeTime === t ? "active" : ""}`}
                  onClick={() => setActiveTime(t)}
                >
                  {t >= 60 ? `${t / 60}m` : `${t}s`}
                </button>
              ))}
              <button
                className={`timer-preset-btn ${
                  activeTime === selectedParagraph.estimatedTime ? "active" : ""
                }`}
                onClick={() => setActiveTime(selectedParagraph.estimatedTime)}
              >
                🎯 Auto ({selectedParagraph.estimatedTime}s)
              </button>
            </div>

            {/* Manual Input */}
            <div className="timer-manual-row">
              <label className="timer-manual-label">Custom seconds:</label>
              <input
                type="number"
                min={10}
                max={600}
                value={activeTime}
                onChange={(e) =>
                  setActiveTime(
                    Math.max(10, Math.min(600, Number(e.target.value)))
                  )
                }
                className="timer-number-input"
              />
              <span className="timer-unit">seconds</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TextSelector;